import { render } from "./ServiceDetailKeycloak.vue?vue&type=template&id=1598c1b5"
import script from "./ServiceDetailKeycloak.vue?vue&type=script&lang=js"
export * from "./ServiceDetailKeycloak.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__